import { assocPath, curry, indexOf, pathOr, reduce } from "ramda";
import { AccountId, SpreadPeriodIndex, SpreadSheetType } from "../spread/types";
import { SelectedCell } from "./types";

interface SelectedCellMap {
  [spreadSheetType: string]: {
    [accountId: string]: { [period: string]: boolean };
  };
}

export const buildSelectedCellMap: (
  selectedCells: SelectedCell[]
) => SelectedCellMap = reduce(
  (acc, selectedCell: SelectedCell) =>
    assocPath(
      [
        selectedCell.account.spreadSheetType,
        selectedCell.account.id,
        selectedCell.period
      ],
      true,
      acc
    ),
  {}
);

export const isCellSelected = curry(
  (
    selectedCellMap: SelectedCellMap,
    spreadSheetType: SpreadSheetType,
    accountId: AccountId,
    period: SpreadPeriodIndex
  ): boolean =>
    pathOr(false, [spreadSheetType, accountId, period], selectedCellMap)
);

export const getIndexOfPeriodSelected = curry(
  (
    selectedCellMap: SelectedCellMap,
    spreadSheetType: SpreadSheetType,
    accountId: AccountId
  ): number => {
    const periods = pathOr([], [spreadSheetType, accountId], selectedCellMap);
    return indexOf(true, periods);
  }
);



// WEBPACK FOOTER //
// ./src/spread/model/selectedCells/selectedCellMap.ts